export default {
  data () {
    return {
      collapseAll: false,
      expandAll: false,
      buttonClicked: false
    }
  },
  methods: {
    toggle () {
      this.buttonClicked = false
      this.collapseAll = false
      this.expandAll = false
    },
    collapseAllFunc () {
      this.buttonClicked = true
      this.collapseAll = true
      this.expandAll = false
    },
    expandAllFunc () {
      this.buttonClicked = true
      this.collapseAll = false
      this.expandAll = true
    }
  }
}
